import React      from 'react'
import prettysize from '../../../utils'
import { Modal, Icon, Spin, Select, Cascader, Popover, Button} from 'antd'
import './styles.scss'
import Presets from '../Presets'

export default ({files, presets, directories, on_encode, price_per_gb, loading, visible,
                  on_add_coder_change, on_cancel, on_add_codec, on_remove_preset,
                  on_preset_change, on_directory_change, load_directories,
                  }) => {
  return (
    <Modal title='Video Encoding'
           className  = {'modal-encoding'}
           visible    = {visible}
           closable   = {false}
           onOk       = {()=> on_encode(files)}
           onCancel   = {()=> on_cancel()}
           cancelText = {'Cancel'}
           okText     = {'Encode'}>

      <Spin spinning={loading}>
        <div className='encode-modal rowWrap'>
          <span>For each file, choose encoding presets and the destination of encoded files</span>
          <div className={'items'}>{
              files.map((file, index) =>
                <div className='item columnWrap' key={index}>
                  { file.type === 'FS_FILE_TYPE_FILE' ? <Icon type="file-text"/> : <Icon type="folder" />}
                  <div>
                    <span>{file.basename} </span>
                    <div className={'properties'}>
                      <span>{prettysize(file.size)}</span>
                      <span>{'$' + (price_per_gb * (file.size/(1024*1024*1024))).toFixed(3)}</span>
                    </div>
                  </div>

                  <div className={'presets'}>
                    <Presets file={file} on_remove={on_remove_preset}/>

                    <Popover title="Select Codec and Destination"
                             trigger="click"
                             overlayClassName={'add-codec-popover'}
                             visible={file.add_coder_visible}
                             onVisibleChange={()=> on_add_coder_change(file)}
                             content={(
                               <div className={'controls'}>
                                 <Select
                                   value={file.category + '-' + file.preset}
                                   onSelect={new_preset => on_preset_change(file, new_preset)}
                                   placeholder={'Select a preset'}
                                   dropdownMatchSelectWidth={false}
                                   size={'large'}>
                                   {
                                     (presets||[]).map((pres, i) => (
                                       <Select.OptGroup key={i} label={pres.name}>
                                         {
                                           pres.presets.map(format => (
                                             <Select.Option key={format.value} value={format.value}>{format.name}</Select.Option>
                                           ))
                                         }
                                       </Select.OptGroup>
                                     ))
                                   }
                                 </Select>

                                 <Cascader size          = {'large'}
                                           placeholder   = {'Select destination'}
                                           expandTrigger = "hover"
                                           options       = {directories}
                                           onChange      = {(values, options)=> on_directory_change(file, values, options)}
                                           loadData      = {load_directories}
                                           changeOnSelect/>

                                 <div className={'popover-controls'}>
                                   <Button onClick={()=> on_add_codec(file)} size={'small'}>
                                     cancel
                                   </Button>
                                   <Button onClick={()=> on_add_codec(file, true)} size={'small'} disabled={!file.cloud_account_id || !file.bucket_name} >
                                     <Icon type="plus" />add
                                   </Button>
                                 </div>
                               </div>
                             )}>

                      <Button onClick={()=>on_add_coder_change(file, true)} size={'small'}>
                        <Icon type="plus" />add {file.presets.length > 0?'More' :''} Presets
                      </Button>
                    </Popover>
                  </div>
                </div>
              )
            }
          </div>
        </div>
      </Spin>
    </Modal>
  )
}
